import React, { useRef, useState } from 'react'
import ProductCard from './ProductCard';
import { formatPrice } from '../../shared/utils';
import { useAppContext } from '../../../context';
import { useNavigate } from 'react-router-dom';

export default function Banner({ wishlist = [], setPage, PRODUCTS = [], CATEGORIES = [] }) {
    const [category, setCategory] = useState("All");
    const filtered = category === "All" ? PRODUCTS : PRODUCTS.filter(p => p.category === category);
    const scrollRef = useRef(null);
  const { addToCart } = useAppContext();
   const navigate = useNavigate();

    const scroll = (dir) => {
    if (scrollRef.current) scrollRef.current.scrollBy({ left: dir * 300, behavior: "smooth" });
    };

    return (
    <div className="bg-white min-h-screen">
        {/* Colorful top bar */}
        <div className="bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 text-white text-center py-2 text-xs font-semibold">
        🎉 FREE DELIVERY on orders above $30 | Use code GAMAPA10 for 10% off
        </div>

        {/* Hero - Split with color blocks */}
        <section className="max-w-7xl mx-auto px-4 pt-2  pb-6">
        <div className="relative bg-gradient-to-br from-red-200 via-red-50 to-amber-50 rounded-[2rem] overflow-hidden p-10 md:p-16">
            <div className="absolute top-0 right-0 w-80 h-80 bg-orange-200 rounded-full -translate-y-1/2 translate-x-1/2 opacity-50"></div>
            <div className="absolute bottom-0 left-1/3 w-40 h-40 bg-red-200 rounded-full translate-y-1/2 opacity-40"></div>
            <div className="relative z-10 grid md:grid-cols-2 gap-10 items-center">
            <div>
                <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
               🔥 Fresh & Hot Delivery in 30 min
                </div>
                <h1 className="text-5xl md:text-6xl font-black text-gray-900 leading-none mb-4">
                Taste the<br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-500">Tradition</span>
                </h1>
                <p className="text-gray-600 mb-8">Handcrafted South Indian delicacies, made with authentic spices and recipes passed down for generations.</p>
                <div className="flex gap-3 flex-wrap">
                <button onClick={() => navigate("/menu")} className="bg-gradient-to-r from-orange-500 to-red-500 text-white font-black px-8 py-4 rounded-2xl shadow-xl shadow-orange-200 hover:scale-105 transition-transform">
                    Order Now
                </button>
                <button onClick={() =>  navigate("about")} className="border-2 border-gray-200 text-gray-700 font-semibold px-8 py-4 rounded-2xl hover:border-orange-300 transition-colors">
                    Our Story
                </button>
                
                </div>
                <div className="flex gap-8 mt-10">
              {[["50+","Menu Items"],["4.9","Rating"],["10k+","Happy Customers"]].map(([v,l]) => (
                <div key={l}>
                  <div className="text-2xl font-black text-black-300">{v}</div>
                  <div className="text-xs text-grey-500">{l}</div>
                </div>
              ))}
            </div>
                
            </div>
            <div className="hidden md:grid grid-cols-2 gap-3">
                {PRODUCTS.slice(0,4).map((p, i) => (
                <div key={p.id} className={`rounded-2xl overflow-hidden shadow-lg hover:scale-105 transition-transform cursor-pointer ${i === 1 ? "translate-y-4" : i === 3 ? "-translate-y-4" : ""}`}
                    onClick={() => addToCart(p)}>
                    <img src={p?.images?.image} alt={p.name} className="w-full h-28 object-cover" />
                    <div className="bg-white p-2">
                    <div className="font-bold text-xs text-gray-800">{p.name}</div>
                    <div className="text-orange-500 font-black text-xs">{p.price}</div>
                    </div>
                </div>
                ))}
            </div>
            </div>
        </div>
        </section>

         {/* Highlights Bar */}
        <section className="max-w-7xl mx-auto px-4 mb-10">
            <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-3xl p-6 grid grid-cols-2 md:grid-cols-4 gap-6 border border-orange-100">
            {[["🚀","Fast Delivery","30 min guaranteed"],["🌿","100% Fresh","Made to order"],["⭐","Top Rated","4.9/5 stars"],["🛡️","Safe & Hygienic","FSSAI certified"]].map(([e,t,s]) => (
                <div key={t} className="flex items-start gap-3">
                <span className="text-2xl">{e}</span>
                <div>
                    <div className="font-bold text-gray-900 text-sm">{t}</div>
                    <div className="text-gray-500 text-xs">{s}</div>
                </div>
                </div>
            ))}
            </div>
        </section>

        {/* Category Chips 
        <section className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
            {CATEGORIES.map(c => (
            <button key={c} onClick={() => setCategory(c)}
                className={`flex-shrink-0 px-5 py-2.5 rounded-full text-sm font-bold transition-all
                ${category === c ? "bg-orange-500 text-white shadow-md shadow-orange-200" : "bg-gray-100 text-gray-500 hover:bg-orange-50 hover:text-orange-500"}`}>
                {c}
            </button>
            ))}
        </div>
        </section> */}

        {/* Horizontal Scroll Products */}
        <section className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-black text-gray-900">🔥 Popular Right Now</h2>
            <div className="flex gap-2">
            <button onClick={() => scroll(-1)} className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center hover:bg-orange-100 transition-colors">←</button>
            <button onClick={() => scroll(1)} className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center hover:bg-orange-100 transition-colors">→</button>
            </div>
        </div>
        <div ref={scrollRef} className="flex gap-5 overflow-x-auto pb-4" style={{scrollSnapType: "x mandatory", scrollbarWidth: "none"}}>
            {filtered.map(p => (
            <div key={p.id} className="flex-shrink-0 w-60" style={{scrollSnapAlign: "start"}}>
                <ProductCard product={p}   isWishlisted={wishlist.includes(p.id)} />
            </div>
            ))}
        </div>
        </section>

        {/* All Products Grid */}
         { /* <section className="max-w-7xl mx-auto px-4 py-8">
        <h2 className="text-2xl font-black text-gray-900 mb-6">📋 Full Menu</h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {filtered.map(p => (
            <ProductCard key={`g-${p.id}`} product={p} onAddToCart={onAddToCart} onWishlist={onWishlist} isWishlisted={wishlist.includes(p.id)} />
            ))}
        </div> 
        </section> */ }

        

    </div>
    );  
}
